var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{bold: _vm.highlight.bold, bg1: _vm.highlight.bg1, bg2: _vm.highlight.bg2},on:{"mouseover":_vm.handleMouseover,"mouseleave":_vm.handleMouseleave}},[_vm._v(_vm._s(_vm.display))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcc1d4c0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormulaSpan.vue
// module id = 33
// module chunks = 0